const config = {
	APP_URL: process.env.NODE_ENV === 'production' ? 'api/' : 'http://xtester.webdev.co.lan/zabmon.app/',
	MESSAGES: {
		'auth-need': 'Требуется авторизация.',
		'unauthorized': 'Пользователь не авторизован.',
		'bad-request': 'Пустой логин и/или пароль',
		'failed': 'Проблемы с кнопкой',
		'notFound': 'Страница не существует',
		'forbidden': "Доступ заблокирован.",
		'network': 'Произошла ошибка подключения.<br>Сервис временно недоступен',
		401: 'Ошибка авторизации.',
	},

	VERSION: '0.9.4'



}

export { config }